import { useColors } from './useColors';
import { useTypography } from './useTypography';
import { brandingColorsOptions, EBrandingColorsOptions } from '../types/coreEntites/Organization';

type TTypographyOptions = 'fontPrimary' | 'fontFamily';

enum ETypography {
	fontPrimary = 'fontPrimary',
	fontFamily = 'fontFamily',
}

export interface BrandingProps {
	createdAt?: string;
	id?: number;
	key: brandingColorsOptions | TTypographyOptions;
	organizationId?: number;
	updatedAt?: string;
	value: string;
}

// const temp = {
//   brandPrimary: '#000',
//   brandSecondary: '#9c1b30',
//   brandPrimaryLight: '#414141',
//   brandSecondaryLight: '#B8263B',
//   formInputBg: '#FFBCC6',
//   formControlBg: '#FAF3F3',
//   whiteLine: '#FFF2F4',
//   opacityBackground: '#9c1b30',
//   fontFamily: 'Optima',
//   // grayBorder: '',
//   // lightGreenBorder: '',
//   // redBorder: '',
//   // darkGray: '',
//   // textColor: '',
//   // black: '',
//   // white: '',
//   // dangerRed: '',
//   // successGreenText: '',
//   // successGreenBg: '',
//   // btnGreenBg: '',
//   // searchTabText: '',
//   // grayText: '',
// };

export const useBranding = () => {
	const { colors, setColors } = useColors();
	const { typography, setTypography } = useTypography();

	function isItBrandingColors(key: unknown): key is brandingColorsOptions {
		return typeof key === 'string' && key in EBrandingColorsOptions;
	}

	function isItTypography(key: unknown): key is TTypographyOptions {
		return typeof key === 'string' && key in ETypography;
	}

	const setBranding = (brandings: BrandingProps[]) => {
		const brandingStyling = { ...colors };
		const typographyStyle = { ...typography };
		if (Boolean(brandings?.length)) {
			for (const { key, value } of brandings) {
				if (isItBrandingColors(key)) {
					brandingStyling[key] = value;
				}
				if (isItTypography(key)) {
					//   until we change in the api fontfamily to fontPrimary
					if (key === 'fontFamily') {
						typographyStyle.fontPrimary = value;
					} else {
						typographyStyle[key] = value;
					}
					const element = document.querySelectorAll('BODY')[0] as HTMLElement;
					element.style.fontFamily = value;
				}
			}
		}

		setTypography(typographyStyle);
		setColors({ colors: { ...brandingStyling } });
	};
	return { setBranding };
};
